// extracted by mini-css-extract-plugin
module.exports = {"background":"CheckoutSideCreditCard_background__US8rM","headLine":"CheckoutSideCreditCard_headLine__nViTE","featuresList":"CheckoutSideCreditCard_featuresList__ejh5i"};